// ── Investments Engine ────────────────────────────────────────────────────────

/** Modal yang diinvestasikan (harga beli × qty) */
export function getInvested(inv) {
  if (inv.type === "saham_idx") return (inv.lot || 0) * 100 * (inv.avgPrice || 0);
  return (inv.unit || 0) * (inv.avgPrice || 0);
}

/** Nilai pasar sekarang (harga sekarang × qty) */
export function getCurrent(inv) {
  if (inv.type === "saham_idx") return (inv.lot || 0) * 100 * (inv.currentPrice || 0);
  return (inv.unit || 0) * (inv.currentPrice || 0);
}

/**
 * Summary total portofolio
 * @returns {{ totalModal, totalNilai, totalGL, returnPct }}
 */
export function getPortfolioSummary(investments) {
  const totalModal = investments.reduce((a, i) => a + getInvested(i), 0);
  const totalNilai = investments.reduce((a, i) => a + getCurrent(i), 0);
  const totalGL    = totalNilai - totalModal;
  return {
    totalModal, totalNilai, totalGL,
    returnPct: totalModal > 0 ? totalGL / totalModal : 0,
  };
}

/**
 * Alokasi per tipe aset
 * @returns {Array<{ label, nilai, modal, gl, returnPct, alokasi }>}
 */
export function getAllocationByType(investments, typeMeta) {
  const map = {};
  investments.forEach(inv => {
    const key = typeMeta[inv.type]?.label || inv.type;
    if (!map[key]) map[key] = { nilai: 0, modal: 0 };
    map[key].nilai += getCurrent(inv);
    map[key].modal += getInvested(inv);
  });
  const totalNilai = Object.values(map).reduce((a, v) => a + v.nilai, 0);
  return Object.entries(map)
    .map(([label, { nilai, modal }]) => {
      const gl = nilai - modal;
      return { label, nilai, modal, gl, returnPct: modal > 0 ? gl / modal : 0, alokasi: totalNilai > 0 ? nilai / totalNilai : 0 };
    })
    .sort((a, b) => b.nilai - a.nilai);
}

/**
 * Alokasi per kelompok/portfolio
 * @returns {Array<{ label, nilai, modal, gl, returnPct, alokasi }>}
 */
export function getAllocationByGroup(investments) {
  const map = {};
  investments.forEach(inv => {
    const key = inv.group || "Lainnya";
    if (!map[key]) map[key] = { nilai: 0, modal: 0 };
    map[key].nilai += getCurrent(inv);
    map[key].modal += getInvested(inv);
  });
  const totalNilai = Object.values(map).reduce((a, v) => a + v.nilai, 0);
  return Object.entries(map)
    .map(([label, { nilai, modal }]) => {
      const gl = nilai - modal;
      return { label, nilai, modal, gl, returnPct: modal > 0 ? gl / modal : 0, alokasi: totalNilai > 0 ? nilai / totalNilai : 0 };
    })
    .sort((a, b) => b.nilai - a.nilai);
}

/**
 * Detail per instrumen dengan G/L
 * @returns {Array<{ ...inv, invested, current, gl, returnPct }>}
 */
export function getInstrumentDetail(investments) {
  return [...investments]
    .map(inv => {
      const invested = getInvested(inv);
      const current  = getCurrent(inv);
      const gl       = current - invested;
      return { ...inv, invested, current, gl, returnPct: invested > 0 ? gl / invested : 0 };
    })
    .sort((a, b) => b.current - a.current);
}
